module.exports = "https://img1.huilianyi.com/9/close-v3.98fb2adb9a.appcore.png";